import React from "react";

const AdminTransactionsICon = ({ width, height, color }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9066 5.88C22.9066 4.10667 24.3466 2.66667 26.12 2.66667C27.8933 2.66667 29.3333 4.10667 29.3333 5.88C29.3333 7.65333 27.8933 9.09333 26.12 9.09333C24.3466 9.09333 22.9066 7.65333 22.9066 5.88ZM17.7732 19.6791L21.6265 14.7071L21.5732 14.7337C21.7865 14.4404 21.8265 14.0671 21.6798 13.7337C21.5345 13.4004 21.2132 13.1737 20.8678 13.1471C20.5065 13.1071 20.1478 13.2671 19.9332 13.5604L16.7078 17.7337L13.0132 14.8271C12.7865 14.6537 12.5198 14.5857 12.2532 14.6137C11.9878 14.6537 11.7478 14.7991 11.5865 15.0124L7.64117 20.1471L7.55984 20.2671C7.33317 20.6924 7.43984 21.2391 7.83984 21.5337C8.0265 21.6537 8.2265 21.7337 8.45317 21.7337C8.76117 21.7471 9.05317 21.5857 9.23984 21.3337L12.5865 17.0257L16.3865 19.8804L16.5065 19.9591C16.9332 20.1857 17.4665 20.0804 17.7732 19.6791ZM20.5998 5.0404C20.5465 5.37373 20.5198 5.70707 20.5198 6.0404C20.5198 9.0404 22.9465 11.4657 25.9332 11.4657C26.2665 11.4657 26.5865 11.4271 26.9198 11.3737V22.1324C26.9198 26.6537 24.2532 29.3337 19.7198 29.3337H9.86784C5.33317 29.3337 2.6665 26.6537 2.6665 22.1324V12.2671C2.6665 7.73373 5.33317 5.0404 9.86784 5.0404H20.5998Z"
        fill="#D9D9D9"
      />
    </svg>
  );
};

export default AdminTransactionsICon;
